import { Collection } from 'modules/core/lib/mobx-rest'

import Location from 'modules/locations/store/models/Location'
import type WorkArea from 'modules/locations/store/models/WorkArea'

class Locations extends Collection<Location> {
  get cacheKey(): string {
    return 'locations'
  }

  model() {
    return Location
  }
}

const singleton: Locations = new Locations()

export const workAreaOptionName = (workArea: WorkArea) => {
  const locationId = workArea.attributes.location_id
  const location = singleton.get(locationId)

  return `${location?.name} - ${workArea.name}`
}

export const employeeLocation = (employeeLocationId: number) => {
  return singleton.get(employeeLocationId)
}
export const companyMainLocation = () => {
  const location = singleton.find({
    main: true,
  })

  if (!location) throw Error('Company without main location')

  return location
}

export const companyDefaultDomain = (domainsList: string[]) => {
  return (
    domainsList.find((item) => item.includes(companyMainLocation().attributes.country)) ||
    domainsList[0]
  )
}

export { Locations }

export default singleton
